import { Link } from "react-router-dom";
import { STATES } from "../../data/content";

export const StatesGrid = () => {
    return (
        <section
            id="states"
            data-testid="states-section"
            className="relative bg-stone py-28 md:py-40"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14">
                <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-7 reveal">
                        <p className="text-xs uppercase tracking-[0.28em] text-terracotta mb-6">
                            — Eight states, eight worlds
                        </p>
                        <h2 className="font-serif text-forest text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-light">
                            Each one its own <em className="italic">weather</em>,
                            <br className="hidden md:block" />
                            its own <em className="italic">grammar</em>,
                            <br className="hidden md:block" />
                            its own kind of <em className="italic text-terracotta">silence</em>.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-4 md:col-start-9 reveal flex items-end">
                        <p className="text-slatewarm text-[17px] leading-relaxed">
                            We don't think of the Northeast as one place. It is eight conversations
                            in eight languages, often inside the same valley. Pick a doorway. We'll
                            help you walk through it.
                        </p>
                    </div>
                </div>

                {/* Bento grid */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-6 lg:auto-rows-[310px]">
                    {STATES.map((s, i) => (
                        <StateCard key={s.slug} state={s} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
};

const StateCard = ({ state, index }) => {
    return (
        <Link
            to={`/states/${state.slug}`}
            data-testid={`state-card-${state.slug}`}
            className={`group relative overflow-hidden bg-forest reveal block ${state.span} ${state.height}`}
            style={{ transitionDelay: `${(index % 4) * 80}ms` }}
        >
            <img
                src={state.image}
                alt={`${state.name} — ${state.tagline}`}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                loading="lazy"
                decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-forest/95 via-forest/40 to-forest/10" />

            <div className="relative z-10 h-full flex flex-col justify-between p-7 md:p-9">
                <div className="flex items-start justify-between">
                    <span className="text-marigold/90 text-[11px] uppercase tracking-[0.3em] font-medium">
                        {String(index + 1).padStart(2, "0")} / 08
                    </span>
                    <span className="text-paper/70 text-[11px] uppercase tracking-[0.22em]">
                        {state.season.split("·")[0].trim()}
                    </span>
                </div>

                <div className="max-w-md">
                    <h3 className="font-serif text-paper text-3xl md:text-5xl leading-[1.05] tracking-tight font-light">
                        {state.name}
                    </h3>
                    <p className="mt-2 text-marigold italic font-serif text-lg md:text-xl">
                        {state.tagline}
                    </p>
                    <p className="mt-5 text-paper/85 text-[14px] md:text-[15px] leading-relaxed max-w-md opacity-0 group-hover:opacity-100 transition-opacity duration-500 hidden md:block">
                        {state.body}
                    </p>
                    <p className="mt-4 text-paper/60 text-[11px] uppercase tracking-[0.22em] flex items-center gap-2">
                        {state.season}
                        <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-marigold" aria-hidden>→</span>
                    </p>
                </div>
            </div>
        </Link>
    );
};
